 import styles from "../../pages/sch-test/delhi-prefit.module.css";
 import ReCAPTCHA from "react-google-recaptcha";
 import { MultiSelect } from "react-multi-select-component";
 import { tnpscnewuser } from "../Service/tnpscprelimsmocktestnew";
 import { tnpscmailcnfm } from "../Service/tnpscprelimsmocktestnew";
 import { useState } from "react";
 import dynamic from 'next/dynamic';
import Otpverification from "../Modal/Otpverification";

 export const NewStudentForm = () =>{
 
     const  options  = [
         { value: 'GroupI-Prelims-TestSeries', label: 'TNPSC Group I Prelims Test Series' },
         { value: 'GroupI-Mains-TestSeries', label: 'TNPSC Group I Mains Test Series' },
         { value: 'GroupII/IIA-Prelims-TestSeries', label: 'TNPSC Group II/IIA Prelims Test Series' },
         { value: 'GroupII-Mains-TestSeries', label: 'TNPSC Group II Mains Test Series' },
         { value: 'GroupIV-TestSeries', label: 'TNPSC Group IV Test Series' },
         { value: 'TNUSRB-TestSeries', label: 'TNUSRB Test Series' },
         { value: 'GroupIV-Classcum-Workshop', label: 'TNPSC Group IV - Class cum Workshop' },
         { value: 'GroupI/II-Regular-Class', label: 'TNPSC Group I/II Regular Class' },
         { value: 'TNPSC-PCM-Batch', label: 'TNPSC PCM Batch' },
         { value: 'GroupI-Mains-CrashCourse', label: 'TNPSC Group I Mains Crash Course' },
         { value: 'GroupII-Mains-CrashCourse', label: 'TNPSC Group II Mains Crash Course' },
         { value: 'UPSC-Course', label: 'UPSC Course' },
       ]
     const [verified, setverified] = useState(false);
     const [preview, setPreview] = useState(null);
     const [isLoading, setIsLoading] = useState(false);
     const [modalOtp, setModalOtp] = useState(false); 
     const [modalOtpstatus, setmodalOtpstatus] = useState(null);
     const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
     const [valuephno, setvaluephno] = useState(undefined);
     const [captchaerror, setcaptchaerror] = useState(undefined);
     const [selectedRadio, setSelectedRadio] = useState();
     const [imgerror, setimgerror] = useState(undefined);
     const [base64ImageToUpload, setbase64ImageToUpload] = useState();
 
     const [selected, setSelected] = useState([]);
     const [formData, setFormData] = useState({ selectedData: '' });
     const [paymentData, setPaymentData] = useState([]); 
     
 
   const handleChange = (selectedOptions) => {
     setSelected(selectedOptions);
 
     // Convert selected options to JSON string
     const jsonString = JSON.stringify(selectedOptions.map(option => option.value));
     const jsonString2=JSON.parse(jsonString);
     
     // Update the formData state with the comma-separated values
     setFormData({selectedData: jsonString2 });
 };
    
     //const [base64PdfToUpload, setbase64PdfToUpload] = useState();
     const HandleChangeValue = (e) => {
         setSelectedRadio(e.target.value);
         if (e.target.value == 'Online'){
             document.getElementById("branch").value = ''
         }
     };
 
     function onChange(value) {
         if (value == null) {
             setverified(false);
         }
         else {
             setverified(true);
         }
     }
     const uploadDocument = async (event, type) => {
         const file = event.target.files[0];
         const base64 = await convertBase64(file);
         console.log(base64);
         const updloadFile = {
           "name": file.name,
           "type": file.type,
           "content": base64.split(",")[1],
           "base64": base64
         }
         if (type == "image") {
           setbase64ImageToUpload(updloadFile);
         }
       };
       //console.log(base64ImageToUpload); // Check if myObject is undefined
       //console.log(base64ImageToUpload?.base64); 
     const convertBase64 = (file) => {
         return new Promise((resolve, reject) => {
           const fileReader = new FileReader();
           fileReader.readAsDataURL(file);
     
           fileReader.onload = () => {
             resolve(fileReader.result);
           };
     
           fileReader.onerror = (error) => {
             reject(error);
           };
         });
       };

    const imageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        console.log(file.size);

        if (file.size <= 1024 * 1024) {
          setimgerror(false);

        
          const base64 = await convertBase64(file);
          setPreview(base64);

          // ✅ KEEP your original backend flow
          uploadDocument(e, "image");

        } else {
          setimgerror(true);

          setTimeout(() => setimgerror(false), 3000);

          setPreview(null);
          e.target.value = "";
        }
      };

   
      // console.log(imageUpload);
       function convertJsonStringToNumber(jsonString) {
         // Parse the JSON string to an object
         const jsonObject = JSON.parse(jsonString);
       
         // Iterate over the keys and convert numeric strings to numbers
         for (const key in jsonObject) {
           if (jsonObject.hasOwnProperty(key)
     && !isNaN(jsonObject[key])) {
             jsonObject[key] = Number(jsonObject[key]);
           }
         }
       
         return jsonObject;
       }
     async function handleOnSubmit(e) {
         e.preventDefault();
      if (verified) {
             const formData = {};
             Array.from(e.currentTarget.elements).forEach(field => {
                 if (!field.name) return;
                 if (field.type === "radio") {
                     if (field.checked) {
                         formData[field.name] = field.value;
                     }
                 } else {
                     formData[field.name] = field.value;
                 }
             });
             formData['formType'] = "tnpscgrp2prelimsMocktest"; 
             formData['title'] = "TNPSC GRPII & IIA Prelims MockTest  Registration 2026";
             //formData['branch'] = props.branchname;
             formData["imagefile"] = base64ImageToUpload;    
             formData["photo"] = base64ImageToUpload.base64;

            const testTitle = "TNPSC GR II-IIA Prelims Mock test 2026";
            const testFees = 100;
            const modeOfTest = "Offline";

            const paymentDatav ={
              testTitle,
              name: formData['name'],
              phoneNo: formData['phoneNo'],
              emailaddress: formData['emailaddress'],
              modeOfTest,
              testcenter: formData['testcentre'],
              community: formData['community'],
              testFees: testFees.toString()
            };
            setPaymentData(paymentDatav);
             delete formData["imagefile"];
             delete formData["filename"];
 
            // formData['countryCode'] = "+91";
              formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
              formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
              formData['siaregisterno']=String(formData['phoneNo']).slice(-7);
              const transform={fields:{...formData}};
              console.log(transform);
              tnpscmailcnfm(transform);
              setIsLoading(true);
              tnpscnewuser(transform)
              .then(response => {
              //sessionStorage.setItem('paymentForm', JSON.stringify(transform));
 
              setModalOtp(true);
              setmodalOtpstatus(response.message);
              window.grecaptcha.reset(setverified);
              setverified(false);
                  
              //window.location.href = `https://admissionsv1.shankariasacademy.com/tnpscPayment/Paymentscreen?${(paymentData)}`;
              setvaluephno(undefined);
              document.getElementById("tnpscgrp2prelimsMocktest").reset();
              setIsLoading(false);

              })
              .catch(error => {
              setModalOtp(true);
              setmodalOtpstatus("failure");
              window.grecaptcha.reset(setverified);
              setverified(false);
              setIsLoading(false);
        })
            }

          else {
            setcaptchaerror(true);
            setTimeout(() => {
              setcaptchaerror(false);
            }, 3000);
          }
  
     }
    
  return (
  <>
    {isLoading &&
        <div class="APIPreLoader" id="APIPreLoader">
            <div class="loader">Loading...</div>
        </div>
    }

    <Otpverification show={modalOtp} title={modalOtpstatus} method="POST" action="index.js" frompage="tnpscgrp2prelimsMocktest" payment={paymentData} onHide={() => setModalOtp(false)} />
    <div className="container-fluid pt-3" style={{ background: "#e2f6ff 0% 0% no-repeat padding-box", opacity: "1" }}>
      <div className="row mx-auto pt-3" >
        <div className="col">
            <div className="container pt-2">
              <div className="row">
                <div className="col-12 mx-auto">
                  <h2 className={`${styles.tesfee} text-center`}>TNPSC Group II/IIA Prelims Mock Test Registration - 2026</h2>
                  <form onSubmit={handleOnSubmit} id="tnpscgrp2prelimsMocktest" autoComplete="off">
                    <div className="row pt-4">

                      <div className="col-12 col-xl-4  col-lg-4">
                          <div className="mb-4">
                            <input type="text" className={`${styles.acheiverrank} form-control`} placeholder="Name *" autoComplete="off" name="name" minLength="1" pattern="[A-Z\s]+" required onInput={(e) => {
                              e.target.value = e.target.value.toUpperCase(); }}  />
                          </div>
                      </div>

                      <div className="col-12 col-xl-4 col-lg-4">
                          <div className="mb-4">
                            <input type="email" className={`${styles.acheiverrank} form-control`} placeholder="Email Address *" title="Please enter a valid email address" autoComplete="off" name="emailaddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                          </div>
                      </div>

                      <div className="col-12 col-xl-4 col-lg-4">
                          <div className="mb-4">
                            <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" placeholder="Phone No *" pattern="[0-9]{10}" maxlength="10" required />
                          </div>
                      </div>

                      {/*<div className="col-12 col-xl-3 col-lg-4 ">
                          <div className=" mb-4">
                            <input type="number" className={`${styles.acheiverrank1} form-control`} name="groupIIregistrationNo" placeholder="TNPSC Group II Registration No" pattern="[0-9]{10}" maxlength="10" required />
                          </div>
                      </div> */}

                      <div className="col-12 col-xl-4 col-lg-4 pt-md-4 pt-2">
                          <div className="mb-4">
                              <select className={`${styles.acheiverrank} form-select form-control`} name="community" autoComplete="off" required>
                                <option value="" disabled selected hidden>Select your community *</option>
                                <option value="BC">BC</option>
                                <option value="BCM">BCM</option>
                                <option value="MBC/DNC">MBC/DNC</option>
                                <option value="SC">SC </option>
                                <option value="SCA">SCA </option>
                                <option value="ST">ST</option>
                                <option value="General">General</option>
                              </select>
                          </div>
                      </div>

                      <div className="col-12 col-xl-4 col-lg-4 pt-md-1">
                          <label className={`${styles.mainsmock} form-check-label `}> Date of Birth <sup className= {`${styles.dot}`}>*</sup></label>
                          <div className="mb-4">
                            <input  type="date" className={`${styles.acheiverrank} form-control`}  name="dateofbirth"  required />
                          </div>
                      </div>

                      <div className="col-12 col-xl-4 col-lg-4 pt-md-4 pt-2 ">
                        <div className="mb-4">
                          <select className={`${styles.acheiverrank} form-select form-control`} name="subject" autoComplete="off" required>
                            <option value="" disabled selected hidden>Select your Subject *</option>
                            <option value="GS-GE">GS with GE</option>
                            <option value="GS-GT">GS with GT</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-xl-5 col-lg-4 pt-3">
                        <label label className={`${styles.acheiverrank} form-check-label px-2`}> Gender <sup className= {`${styles.dot}`}>*</sup></label><br/>
                            <input className="form-check-input" type="radio"
                            name="gender"
                            value="male"
                            id="male"
                            required
                            />
                        <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="Male">Male</label>    
                            <input className="form-check-input" type="radio"
                            name="gender"
                            value="female"
                            id="male"
                            required
                            />
                        <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="Male">Female</label>
                            <input className="form-check-input" type="radio"
                            name="gender"
                            value="others"
                            id="male"
                            required
                            />
                        <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="Female">Others</label>
                      </div>

                      <div className="col-12 col-xl-4 col-lg-4 pt-3">
                        <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="Are you Ex-service man?">Are you Ex-service man?<sup className= {`${styles.dot}`}>*</sup></label> <br/>                                              
                            <input className="form-check-input" type="radio"
                              name="ex-serviceman"
                              value="yes"
                              id="yes"
                              required
                            />
                          <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="Yes">Yes</label>                     
                            <input className="form-check-input" type="radio"
                              name="ex-serviceman"
                              value="no"
                              id="no"
                              required
                            />
                        <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="No">No</label>
                      </div>

                      <div className="col-12 col-xl-3 col-lg-4 pt-3">
                          <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="Are you disabled?">Are you disabled?<sup className= {`${styles.dot}`}>*</sup></label> <br/>

                          <input className="form-check-input" type="radio"
                            name="disabled"
                            value="yes"
                            id="yes"
                            required
                          />
                          <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="Yes">Yes</label>
                                              
                          <input className="form-check-input" type="radio"
                            name="disabled"
                            value="no"
                            id="no"
                            required
                          />
                          <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="No">No</label>
                      </div>

                      <div className="col-12 col-xl-4 col-lg-4 pt-5">
                          <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="Are you PSTM Candidate?">Are you PSTM Candidate? <sup className= {`${styles.dot}`}>*</sup></label> <br/>
                          <input className="form-check-input" type="radio"
                            name="pstmcandidate"
                            value="yes"
                            id="yes"
                            required        
                          />
                          <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="Yes">Yes</label>
                          <input className="form-check-input" type="radio"
                            name="pstmcandidate"
                            value="no"
                            id="no"
                            required
                          />
                          <label className={`${styles.acheiverrank} form-check-label px-2`} htmlFor="No">No</label>
                      </div>

                      <div className="col-12 col-xl-4 col-lg-4 pt-5">
                        <div className="mb-2">
                          <select className={`${styles.acheiverrank} form-select form-control`} name="nativedistrict" autoComplete="off" required>
                              <option value="" disabled selected hidden>Select your Native District  *</option>
                              <option value="Ariyalur ">Ariyalur </option>
                              <option value="Chengalpattu">Chengalpattu </option>
                              <option value="Chennai">Chennai</option>
                              <option value="Coimbatore">Coimbatore</option>
                              <option value="Cuddalore">Cuddalore</option>
                              <option value="Dharmapuri">Dharmapuri</option>
                              <option value="Dindigul">Dindigul</option>
                              <option value="Erode">Erode</option>
                              <option value="Kallakurichi">Kallakurichi</option>
                              <option value="Kanchipuram">Kanchipuram</option>
                              <option value="Kanniyakumari">Kanniyakumari</option>
                              <option value="Karur">Karur</option>
                              <option value="Krishnagiri">Krishnagiri</option>
                              <option value="Madurai">Madurai </option>
                              <option value="Mayiladuthurai">Mayiladuthurai</option>
                              <option value="Nagapattinam">Nagapattinam</option>
                              <option value="Namakkal">Namakkal</option>
                              <option value="Nilgiris">Nilgiris</option>
                              <option value="Perambalur">Perambalur</option>
                              <option value="Pudukkottai">Pudukkottai</option>
                              <option value="Ramanathapuram">Ramanathapuram</option>
                              <option value="Ranipet ">Ranipet </option>
                              <option value="Salem">Salem</option>
                              <option value="Sivagangai">Sivagangai</option>
                              <option value="Tenkasi">Tenkasi</option>
                              <option value="Thanjavur">Thanjavur</option>
                              <option value="Thoothukudi">Thoothukudi</option>
                              <option value="Tiruchirappalli">Tiruchirappalli</option>
                              <option value="Tirunelveli">Tirunelveli</option>
                              <option value="Tirupathur">Tirupathur</option>
                              <option value="Tiruppur">Tiruppur</option>
                              <option value="Tiruvallur">Tiruvallur</option>
                              <option value="Tiruvannamalai">Tiruvannamalai</option>
                              <option value="Tiruvarur">Tiruvarur</option>
                              <option value="Vellore">Vellore </option>
                              <option value="Viluppuram">Viluppuram</option>
                              <option value="Virudhunagar ">Virudhunagar</option>
                            </select>
                        </div>
                      </div>

                      <div className="col-12 col-xl-4  col-lg-4 pt-md-5 pt-2">
                        <div className="mb-4">
                          <select className={`${styles.acheiverrank} form-select form-control`} name="testcentre" autoComplete="off" required>
                            <option value="" disabled selected hidden>Mock Test Centre *</option>
                            <option value="AnnaNagar-Chennai">AnnaNagar-Chennai</option>
                            <option value="Adyar-Chennai">Adyar-Chennai</option>
                            <option value="Salem">Salem</option>
                            <option value="Madurai">Madurai</option>
                            <option value="Trichy">Trichy</option>
                            <option value="Namakkal">Namakkal</option>
                            <option value="Thiruvarur">Thiruvarur</option>
                            <option value="Coimbatore">Coimbatore</option>
                            {/* <option value="Kancheepuram">Kancheepuram</option>
                            <option value="Vellore">Vellore</option>
                            <option value="Tirunelveli">Tirunelveli</option>
                            <option value="Krishnagiri">Krishnagiri</option>
                            <option value="Erode">Erode</option>
                            <option value="Cuddalore">Cuddalore</option> */}
                          </select>
                        </div>
                      </div>

                      <div className="col-12 col-xl-4 col-lg-4 pt-md-5 pt-2">
                         <p>Are you student of Shankar IAS Academy? <sup className= {`${styles.dot}`}>*</sup></p>
                         <label className={`${styles.mainsmock} form-check-label px-2`}> </label>
                            <input className="form-check-input" type="radio"
                              name="ifsia"
                              value={"Yes"}
                              id="IfSIAYes"
                              required
                              onChange={HandleChangeValue}  
                            />
                          <label className={`${styles.mainsmock} form-check-label px-2`} htmlFor="Online"> Yes</label>
                            <input className="form-check-input" type="radio"
                              name="ifsia"
                              value={"No"}
                              id="IfSIANo"
                              required
                              onChange={HandleChangeValue}
                            />
                          <label className={`${styles.mainsmock} form-check-label px-2`} htmlFor="Offline">No</label>
                      </div>

                      <div className="col-12 col-xl-4 col-lg-4 pt-4">
                        <label className={`${styles.mainsmock} form-check-label px-2 py-2`} htmlFor="Offline"> If yes, specify the programme name</label>
                        <div className="mb-4">
                          <input type="hidden" name="programme" value={formData.selectedData} />  
                            <MultiSelect
                              options={options}
                              value={selected}
                              onChange={handleChange}
                              labelledBy="Select"
                              disabled={selectedRadio ===  'No' ? 'Yes' : ''}
                              placeholder="If yes, specify the programme name"              
                            />
                        </div>
                      </div>

                       <div className="col-12 col-xl-4 col-lg-4 pt-4">
                          <div className="mb-4">
                              <label className="form-label mb-2 " htmlFor="imagefile">
                                <span style={{ textAlign: "center" }}>  Passport size photo </span><sup className= {`${styles.dots}`}>*</sup>
                              </label>

                              {/* Hidden Input */}
                              <input
                                type="file"
                                id="imagefile"
                                name="imagefile"
                                accept="image/png,image/jpeg"
                                onChange={imageUpload}
                                style={{ display: "none" }}
                              />

                              {/* Circle Upload */}
                              <div
                                onClick={() => document.getElementById("imagefile").click()}
                                style={{
                                width: "140px",
                                height: "140px",
                                borderRadius: "50%",
                                border: "2px dashed #D9DFE6",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                overflow: "hidden",
                                cursor: "pointer",
                                background: "#f8f9fa",
                                margin: "10px auto"
                                }}
                              >
                              {preview ? (
                                <img
                                src={preview}
                                alt="preview"
                                style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                                }}
                              />
                              ) : (
                                <span style={{ color: "#888", fontSize: "14px" }}>Upload</span>
                                )}
                              </div>

                              {/* Instruction */}
                              <small className="d-block text-center text-muted">
                                Img size should be less than 1 MB (.jpg, .jpeg, .png)
                              </small>

                              {/* Error */}
                              {imgerror && (
                                <div className="text-danger pt-1 text-center">
                                  Please select a photo upto 1 MB
                                </div>
                              )}

                          </div>
                        </div>

                        <div className="col-12 col-lg-5 col-xl-4 mb-3 pt-4">
                            <div className="d-flex flex-column align-items-center align-items-lg-start mt-2">

                              <div className={styles.captchaWrapper}>
                                <ReCAPTCHA
                                  sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                                  onChange={onChange}
                                />
                              </div>

                              {captchaerror && (
                                <div className="text-danger text-center captachafont mt-1">
                                  Please verify the captcha!
                                </div>
                              )}

                            </div>
                        </div>

                        <div className="col-12 col-lg-7 col-xl-8 mb-3">
                          
                          <label className={`${styles.mainsmock} form-check-label px-2 py-2`}>
                            <input
                              className="form-check-input m-2"
                              type="checkbox"
                              name="Agree"
                              value="yes"
                              id={styles.invalidCheck2}
                              required
                            />
                            Declaration<sup className={styles.dot}>*</sup>
                          </label>

                          <label
                            className={`${styles.checkboxcontent} form-check-label`}
                            htmlFor="invalidCheck2"
                          >
                            I hereby declare that the data submitted by me for the State Level
                            TNPSC Group II/IIA Prelims Mock Test 2026 conducted by Shankar IAS
                            Academy is true to the best of my knowledge. Also, I shall agree to
                            submit my TNPSC Group II/IIA Prelims 2026 hall ticket and authorize
                            the Shankar IAS Academy to use candidature for any promotion purpose.
                          </label>

                          <div className="m-3">
                            <button type="submit" className={styles.normalbutton}>
                              Submit
                            </button>
                          </div>
                        </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </>
  );
}
